module.exports = __webpack_public_path__ + "public/images/invite_learners_to_join.f9f31c8fb9d12014451635076248b925.png";